import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { InputNumberModule } from 'primeng/inputnumber';
import { ButtonWithTextMenuArrowComponent } from '../button-with-text-menu-arrow/button-with-text-menu-arrow.component';

@Component({
    selector: 'input-time',
    templateUrl: './input-time.component.html',
    standalone: true,
    imports: [
      FormsModule,
      ButtonWithTextMenuArrowComponent,
      InputNumberModule]
})
export class InputTimeComponent implements OnChanges {
    inputTime:any = {
    listHours: this.generateListHours(),
    itemConfiguration: {
      keyName: 'name',
      maxWidth: '200px',
      type: 'frequency-light',
      orderBy: 'name'
    }
  };

  constructor() { }

  @Input() input:any;
  @Input() disabled:any;
  @Output() output = new EventEmitter();

  ngOnChanges(){
    let that = this.inputTime;
    if (this.input && this.input !== '00:00') {
      let time = this.input.substr(0, 5);
      for (let i = 0; i < that.listHours.length; i++) {
        if(that.listHours[i].name === time){
          that.selectedTime = that.listHours[i];
          break;
        }
      }
    } else {
      that.selectedTime = that.listHours[0];
    }
  }

  generateListHours() {
    const timeHour = [];
    let keyId: number = 0;
    for (let hour = 0; hour < 24; hour++) {
      for (let minute = 0; minute <= 30; minute += 30) {
        const hourStr = String(hour).padStart(2, '0');
        const minuteStr = String(minute).padStart(2, '0');
        let elementHour: any = {
          keyId: keyId,
          name: `${hourStr}:${minuteStr}`
        }
        timeHour.push(elementHour);
        keyId++;
      }
    }
    return timeHour;
  }

  changeView(option: any){
    this.output.emit({newValue: option.name});
  }
}
